const customizer = {
  container: document.querySelector('.customizer__container'),
  menu: document.querySelector('[data-section="nav"]'),
  triggers: document.querySelectorAll('[data-section-trigger]'),
  section: document.querySelectorAll('[data-section]'),
  sectionBlocks: document.querySelectorAll('.form-section__block'),
  button: document.querySelectorAll('[data-btn-action]'),
  viewElements: document.querySelectorAll('[data-current]'),
  clickedItemId: null,
  alerts: {
    font: document.querySelectorAll('[data-alert="font"]'),
    color: document.querySelectorAll('[data-alert="color"]'),
    flag:  document.querySelectorAll('[data-alert="flag"]')
  },
  previewGallery: {
    container: document.querySelector('.customizer__gallery'),
    images: document.querySelectorAll('[data-view-image]'),
    currentImage: document.querySelector('[data-main-view]'),
    viewsList: document.querySelector('.customizer__gallery-views'),
    viewBtns: document.querySelectorAll('[data-view-btn]'),
    customizationLayers: document.querySelectorAll('.gallery__custom-preview')
  },
  buttons: {
    colors: document.querySelectorAll('[data-cyou-color]'),
    views: document.querySelectorAll('[data-view-btn-nav')
  },
  title: document.querySelector('.customizer__title'),
  totalCost: document.querySelector('[data-total-cost'),
  selectedVariants: [],
  displayCost: document.querySelector('.customizer__display-cost'),
  sections: {
    text: {},
    logo: {},
    flag: {},
    cyou: {},
    cyouColor: {},
  },
}

const product = {
  handle: document.querySelector('[data-product-name]').dataset.productName,
  type: document.querySelector('[data-product-type]').dataset.productType,
  variantID: document.querySelector('[data-variant-id]').dataset.variantId,
  variantPrice: document.querySelector('[data-variant-price]').dataset.variantPrice,
  variantSelect: document.querySelector('select.multi_select'),
  totalPrice: document.querySelector('.product__total-price'),
  additionalCost: document.querySelector('.product__additional-cost'),
  additionalCostField: document.querySelector('[data-additional-cost]'),
  totalCostField: document.querySelector('[data-total-cost-field]'),
  priceDisplay: document.querySelector('[data-price-display]')
}

function saveSection (section) {
  customizer.currentSection.dataset.saved = true
  customizer.sections[section].cost.nextElementSibling.children.forEach((child, index) =>  {
    if (child.dataset.current == "true") {
      if (section == 'cyou' ) {
        if (child.parentElement.previousElementSibling.textContent) child.classList.remove('hidden-custom')
      } else {
        if (child.parentElement.previousElementSibling.children[index].textContent) child.classList.remove('hidden-custom')
      }
    }
  })
}


customizer.actions = {
  next: function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      displaySection(customizer.menu)
      btn.classList.remove('show')
    })
  },
  customize: function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      customizer.container.setAttribute('data-open', true)
      document.querySelector('body').classList.add('no-scroll')
    })
  },
  close: function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      document.querySelectorAll('[data-options-product]').forEach((elem, index) => elem.textContent = getCurrentVariantOptions()[index])
      document.querySelector('.customizer__product-variant--product').classList.add('show-flex')
      document.querySelector('body').classList.remove('no-scroll')
      customizer.displayCost.classList.add('show')
      if (customizer.totalAdditionalCost) {
        displayCosts()
      } else {
        hideCosts()
      }
      customizer.container.setAttribute('data-open', false)
    })
  },
  back: function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      switch (customizer.currentSection.dataset.section) {
        case 'text':
          btn.classList.remove('show')
          if (customizer.currentSection.dataset.saved === "false") resetTextSection()
          displaySection(customizer.menu)
          break
        case 'logo':
          btn.classList.remove('show')
          if (customizer.currentSection.dataset.saved === "false") resetLogoSection()
          displaySection(customizer.menu)
          break
        case 'flag':
          btn.classList.remove('show')
          if (customizer.currentSection.dataset.saved === "false") resetFLagSection()
          displaySection(customizer.menu)
          break
        case 'cyou':
          if (customizer.currentSection.dataset.saved === "false") resetCyouSection()
          displaySection(customizer.menu)
          break
        case 'cyou-color':
          displaySection(document.querySelector('[data-section="cyou"]'))
          customizer.buttons.save.classList.add('show') //for color picker section
          break
        case 'select':
          displaySection(customizer.menu)
          if (!lineIds['text'].some(value => value)) getTextColors()
          break
      }
    })
  },
  clear: function (btn) {
    btn.addEventListener('click', clearOptions.bind(btn))
    function clearOptions(e) {
      e.preventDefault()
      e.stopPropagation()
      switch (this.parentElement.previousElementSibling.dataset.cost) {
        case 'text':
          resetTextSection()
          this.classList.add('hidden-custom')
          break
        case 'logo':
          resetLogoSection()
          this.classList.add('hidden-custom')
          break
        case 'flag':
          resetFLagSection()
          this.classList.add('hidden-custom')
          break
        case 'cyou':
          resetCyouSection()
          this.classList.add('hidden-custom')
          break
      }
    }
  },
  clearlogo: function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      e.target.previousElementSibling.value = ''
      e.target.previousElementSibling.dispatchEvent(new Event('change'));
    })
  },
  save: function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault()
      let showMenu = true
      switch (customizer.currentSection.dataset.section) {
        case 'text':
          if (lineIds['text'].some(value => value)) {
            customizer.sections.text.inputs.forEach((elem, index) => {
              if (elem.value) {
                if (!customizer.sections.text.fontInputs[index].value) {
                  customizer.alerts.font[index].textContent = 'Please select a font.'
                  showMenu = false
                }
                if (!customizer.sections.text.colorInputs[index].value) {
                  customizer.alerts.color[index].textContent = 'Please select a color.'
                  showMenu = false
                }
                if (product.type.includes('apron')) {
                  const textLocation = document.getElementById('text-location');
                  const selected = textLocation.options[textLocation.selectedIndex];
                  if (product.type.includes('apron')) {
                    if (!textLocation.value) {
                      document.querySelector('#text-location').classList.add('highlight')
                      document.querySelector('#text-location').scrollIntoView({behavior: "smooth", block: "center"})
                      document.getElementById('#text-location-alert').textContent = 'Please select a location.'
                      showMenu = false
                    } else {
                      document.querySelector('#text-location').classList.remove('highlight')
                      document.getElementById('#text-location-alert').textContent = ''
                    }
                  }
                  if (selected.value.includes('Other') && !document.querySelector('#text-notes-front').value) {
                    document.querySelector('#text-location-alert').textContent = 'Enter a location in additional notes.'
                    document.querySelector('#text-notes-front').classList.add('highlight');
                    showMenu = false
                  } else {
                    document.querySelector('#text-location-alert').textContent = ''
                    document.querySelector('#text-notes-front').classList.remove('highlight');
                  }
                }
                if (customizer.sections.text.fontInputs[index].value && customizer.sections.text.colorInputs[index].value) {
                  saveSection('text')
                  customizer.alerts.font[index].textContent = ''
                  customizer.alerts.color[index].textContent = ''
                }
              } else {
                customizer.sections.text.fontInputs[index].selectedIndex = 0
                document.querySelectorAll('.custom-select--font .select-selected')[index].textContent = 'Select Font'
                customizer.sections.text.colorInputs[index].selectedIndex = 0
              }
            })
          } else {
            resetTextSection()
          }
          break
        case 'logo':
          if (lineIds['logo'].some(value => value)) {
            if (product.type.includes('apron')) {
              const locationFields = document.querySelectorAll('.logo-location-field');
              const logoAlert = document.querySelectorAll('.logo-alert');
              const logoLocationAlert = document.querySelectorAll('.logo-location-alert');

              customizer.sections.logo.inputs.forEach((elem, index) => {
                if (elem.value) {
                  if (!locationFields[index].value) {
                   logoLocationAlert[index].textContent = 'Please select a location.'
                    showMenu = false
                    if (logoAlert[0].textContent) logoAlert[1].textContent = ''
                    if (logoAlert[1].textContent) logoAlert[0].textContent = ''
                  } else {
                    logoLocationAlert[index].textContent = ''
                    const selected = locationFields[index].options[locationFields[index].selectedIndex]
                    if (selected.value.includes('Other') && !document.querySelector('#logo-additional-notes-front').value) {
                      logoLocationAlert[index].textContent = 'Enter a location below.'
                      logoAlert[index].textContent = 'Enter a location in additional notes.'
                      document.querySelector('#logo-additional-notes-front').classList.add('highlight');
                      showMenu = false
                      if (logoAlert[0].textContent) logoAlert[1].textContent = ''
                      if (logoAlert[1].textContent) logoAlert[0].textContent = ''
                    } else {
                      logoAlert[index].textContent = ''
                      logoLocationAlert.forEach(elem => elem.textContent = '')
                      document.querySelector('#logo-additional-notes-front').classList.remove('highlight');
                      saveSection('logo')
                    }
                  }
                }
              })
            } else {
              saveSection('logo')
            }
          } else {
            resetLogoSection()
          }
          break
        case 'flag':
          if (lineIds['flag'].some(value => value)) {
            let notesIndex = 0;
            customizer.sections.flag.inputs.forEach((elem, index) => {
               if (index >= 1) notesIndex = index - 1
               if (elem.value) {
                if (elem.nextElementSibling.selectedIndex <= 0) {
                  customizer.alerts.flag[index].textContent = 'Please select a location.'
                  showMenu = false
                } else if (elem.nextElementSibling.options[elem.nextElementSibling.selectedIndex].value.includes('Other') && !customizer.sections.flag.notes[notesIndex].value) {
                  customizer.alerts.flag[index].textContent = 'Enter a location in additional notes below.'
                  customizer.sections.flag.notes[notesIndex].classList.add('highlight')
                  showMenu = false
                } else {
                  saveSection('flag')
                  customizer.sections.flag.notes[notesIndex].classList.remove('highlight')
                  customizer.alerts.flag[index].textContent = ''
                }
              } else {
                if (elem.id.includes('front')) {
                  if (elem.nextElementSibling.selectedIndex) {
                    elem.nextElementSibling.selectedIndex = 0
                  }
                } else {
                  elem.nextElementSibling.selectedIndex = 3
                }
              }
            })
          } else {
            customizer.sections.flag.inputs.forEach((elem) => {
              if (!elem.value) elem.nextElementSibling.selectedIndex = 0
             })
            resetFLagSection()
          }
          break
        case 'cyou':
          if (lineIds['cyou'].some(value => value)) {
            saveSection('cyou')
          } else {
            resetCyouSection()
          }
          break
      }
      if (showMenu) {
        displaySection(customizer.menu)
        customizer.alerts.font.forEach(elem => elem.textContent = '')
        customizer.alerts.color.forEach(elem => elem.textContent = '')
      }
    })
  },
  done: function (btn) {
    const costData = document.querySelectorAll('.nav__cost')
    const displayCost = document.querySelectorAll('[data-display-cost]')
    btn.addEventListener('click', function (e) {
      document.querySelector('.single-option-selector').dispatchEvent(new Event('change'))
      let destination = document.querySelector('.gallery-cell.is-selected')
      let previousSrc = destination.firstElementChild.firstElementChild.firstElementChild.src
      e.preventDefault()
      document.querySelector('body').classList.remove('no-scroll')
      const [color, sleeves, size] = getCurrentVariantOptions()
      if (customizer.totalAdditionalCost) {
        product.additionalCostField.value = customizer.totalAdditionalCost
        displayCosts()
        if (product.type.includes('jacket')) document.querySelector('[data-view-btn-nav][data-view="front"]').click()
        let frontCustom = document.getElementById('front-custom')
        let clone = frontCustom.cloneNode(true);
        destination = document.querySelector('.gallery-cell.is-selected')
        document.querySelectorAll('.gallery-cell').forEach(elem => {
          if (elem.children.length > 1) elem.removeChild(elem.lastElementChild)
        })
        if (destination.children.length > 1) destination.removeChild(destination.lastElementChild)
        if (customizer.cyouColor) {
          if (product.type.includes('jacket')) {
            destination.firstElementChild.firstElementChild.firstElementChild.srcset =
            `https://cdn.shopify.com/s/files/1/0763/2745/files/${product.handle}-${color.toLowerCase()}-${sleeves.toLowerCase()}-cyou-${customizer.cyouColor}.jpg`
          } else {
            destination.firstElementChild.firstElementChild.firstElementChild.srcset =
              `https://cdn.shopify.com/s/files/1/0763/2745/files/${product.handle}-${color.toLowerCase()}-cyou-${customizer.cyouColor}.jpg`
          }
        }
         
        clone.removeAttribute("id");
        destination.appendChild(clone)
        costData.forEach((elem, index) => {
            displayCost[index].value = elem.textContent
        })
      } else {
        costData.forEach((elem, index) => {
          displayCost[index].value = elem.textContent
      })
      product.totalCostField.value = null;
      product.additionalCostField.value = null;

        hideCosts()
        if (destination.children.length > 1) destination.removeChild(destination.lastElementChild)
      }
      displaySection(customizer.menu)
      customizer.buttons.next.classList.remove('show')
      if (customizer.cyouColor == null) destination.firstElementChild.firstElementChild.firstElementChild.srcset = previousSrc
      customizer.container.setAttribute('data-open', false)
      document.querySelectorAll('[data-options-product]').forEach((elem, index) => elem.textContent = getCurrentVariantOptions()[index])
      document.querySelector('.customizer__product-variant--product').classList.add('show-flex')
    })
  },
  addtocart: function (btn) {
    btn.setAttribute('type', '')
    btn.classList.remove('ajax-submit')
    let addToCartForm = document.querySelector('form[action$="/cart/add"]')
    let variantData = {
      items: [],
    }
    async function addCartItems(selectedVariantsIds, qty) {
      if (product.type.includes('jacket')) {
        if (customizer.sections.flag.inputs) {
          customizer.sections.flag.inputs.forEach(elem => {
            if (!elem.value) {
              elem.nextElementSibling.selectedIndex = 0
            }
          })
        }
      }
      const cart = await getCart();
      const customProductId = Math.floor(Math.random() * 900000) + 100000
      const feeVariants = [39874957279313, 40066009432145, 39919976644689, 39919976677457];
      const cartUploads = [];
      let currentInputs = [];
      let currentUploads = [];

      selectedVariantsIds.forEach((id) => {
        if (feeVariants.includes(parseInt(id))) {
          // console.log('cart')
          // console.log(cart.items)
          for (item of cart.items) {
            const cartItemUploads = []
            if (item.properties.hasOwnProperty('Custom Product ID')) {
              // console.log('item:')
              // console.log(item)
              // console.log('item props:')
              // console.log(item.properties)
              let itemCustomId = item.properties['Custom Product ID'];
              let customData = localStorage.getItem(`customdata-${itemCustomId}`)
              if (customData) customData = JSON.parse(customData);
              for (const [index, custom] of Object.entries(customData)) {
                if (custom.name.includes('Upload')) {
                  if (custom.value != 'data:,') {
                    // console.log(custom.value)
                    if (customizer.clickedItemId) {
                      if (itemCustomId != customizer.clickedItemId) {
                        cartItemUploads.push(custom.value);
                      }
                    } else {
                      cartItemUploads.push(custom.value);
                    }
                  }
                }
              }
              const uniqueUploads = [...new Set(cartItemUploads)];
              for (upload of uniqueUploads) {
                cartUploads.push(upload)
              }
            }
          }

          // console.log('cart uploads: ')
          // console.log(cartUploads)
          if (customizer.clickedItemId) {
            // console.log('yes clicked')
            for (preview of customizer.sections.logo.uploadPreviews) {
              // console.log(preview)
              const base64 = getBase64Image(preview)
              // console.log('base 64')
              // console.log(base64)
              if (base64 != "data:,") {
                currentUploads.push(base64)
              }
              currentInputs.push(base64)
            }
          } else {
            // console.log('no clicked')
            for (input of customizer.sections.logo.uploads) {
              let img = input.parentElement.previousElementSibling.querySelector('img');
              const base64 = getBase64Image(img);
              if (input.value) {
                currentUploads.push(base64)
              }
              currentInputs.push(base64)
            }
          }

          // console.log('current uploads:')
          // console.log(currentUploads)

          const toRemove = new Set(cartUploads);

          let currentUploadsFiltered = currentUploads.filter( x => !toRemove.has(x) );
          // console.log('current uploads: (after filtering cart uploads)')
          // console.log(currentUploadsFiltered)
          const itemsToRemove = new Set(currentUploadsFiltered)

          const filteredItems = currentUploads.filter( x => !itemsToRemove.has(x) );

          // console.log('currentINputs before comparing with currentUploads')
          // console.log(currentInputs)

          // console.log('filetered items')
          // console.log(filteredItems)

          let removedItems = []
          const checkedItems = []
          const currentInputsCopy = currentInputs;

          for (const [index, input] of currentInputs.entries()) {
            // console.log(index)
            // console.log(input)
            if (checkedItems.includes(input)) {
              removedItems.push(currentInputs[index])
              currentInputsCopy[index] = "remove"
            }
            if (filteredItems.includes(input)) {
              removedItems.push(currentInputs[index])
              currentInputsCopy[index] = "remove"
            }
            if (input != "data:,") checkedItems.push(input)
          }

          // console.log('after')
          // console.log(currentInputsCopy)
          const totalPriceDispay = document.querySelector('input[data-total-cost-field]');


          document.querySelectorAll('input[data-logo-display]').forEach( (elem, index) => {
            // console.log(elem)
            // console.log(elem.value)
            if (currentInputsCopy[index] == "remove") {
              elem.value = elem.value.replace(" + $75 fee","");
            }
          })


          currentUploadsFiltered = [...new Set(currentUploadsFiltered)];
          // console.log('current uploads filtered?')
          // console.log(currentUploadsFiltered)

          // console.log(id)
          const previousIndex = feeVariants.indexOf(parseInt(id));
          const newIndex = currentUploadsFiltered.length - 1;
          // console.log('prev index: ' + previousIndex)
          // console.log('new index: ' + newIndex)
          const diff = previousIndex - newIndex
          // console.log('diff: ' + diff)
          
          // console.log('original price: ' + totalPriceDispay.value)
          totalPriceDispay.value = (parseInt(totalPriceDispay.value) - 75 * diff).toString()
          // console.log('after adjustment: ' + totalPriceDispay.value)

          if (currentUploadsFiltered.length >= 1) {
            id = feeVariants[currentUploadsFiltered.length - 1]
            // console.log('fee index')
            // console.log(id)
            variantData.items.push({
                id: id,
                quantity: 1,
                properties: {
                  "Custom ID": `${customProductId}`,
                  For: `${prettify(product.handle)} ${product.variantSelect.options[product.variantSelect.selectedIndex].text}`,
                  _id: `${capitalize(product.variantID)}`
                },
            })
            // console.log(variantData.items)
          }
       } else {
          variantData.items.push({
            id: id,
            quantity: qty,
            properties: {
              "Custom ID": `${customProductId}`,
              For: `${prettify(product.handle)} ${product.variantSelect.options[product.variantSelect.selectedIndex].text}`,
              _id: `${capitalize(product.variantID)}`,
            },
          })
        }
      })
      try {
        // console.log(variantData)
        document.getElementById('custom-id').value = customProductId
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(variantData),
        })
        handleData(`customdata-${customProductId}`)
        await removeCartItems()
        setTimeout(() => {
          addToCartForm.submit()
        }, "800");
      } catch (error) {
        console.log(error)
      }
    }

    btn.addEventListener('click', function (e) {
      e.target.classList.add('disabled')
      e.target.setAttribute('disabled', 'disabled');
      e.target.classList.add('disabled')
      btn.textContent = '...'
      e.preventDefault()
      const lineItems = removeElementsWithValue(customizer.selectedVariants, 0);
      let qty = addToCartForm.querySelector('#quantity').value
      if (lineItems.length > 0) {
        addCartItems(lineItems, qty)
      } else {
        if (customizer.clickedItemId) {
          removeCartItems()
          deteleUnusedFields()
          setTimeout(() => {
            addToCartForm.submit()
          }, "800");
        } else {
          addToCartForm.submit()
        }
      }
    })
  },
}

async function getCart() {
  const result = await fetch("/cart.json");

  if (result.status === 200) {
      return result.json();
  }

  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

function displayCosts() {
  customizer.displayCost.classList.add('show')
  product.additionalCost.textContent = `Additional costs:  $${customizer.totalAdditionalCost}`
  product.totalPrice.textContent = `$${customizer.totalAdditionalCost + parseInt(product.variantPrice.slice(0, -2))}`
  product.totalCostField.value = `${customizer.totalAdditionalCost + parseInt(product.variantPrice.slice(0, -2))}`
  document.querySelector('[data-btn-action="customize"]').textContent = 'Edit';
  product.priceDisplay.classList.add('active')
}

const customizeBtnText = document.querySelector('[data-btn-action="customize"]').textContent

function hideCosts() {
  customizer.displayCost.classList.remove('show')
  document.querySelector('[data-btn-action="customize"]').textContent = customizeBtnText;
  product.priceDisplay.classList.remove('active')
}

customizer.button.forEach((btn) => {
  const action = btn.dataset.btnAction
  switch (action) {
    case 'next': 
      customizer.actions.next(btn)
      customizer.buttons.next = btn
      break
    case 'customize':
      customizer.buttons.customize = btn
      customizer.actions.customize(btn)
      break
    case 'close':
      customizer.buttons.close = btn
      customizer.actions.close(btn)
      break
    case 'back':
      customizer.actions.back(btn)
      customizer.buttons.back = btn
      break
    case 'done':
      customizer.actions.done(btn)
      customizer.buttons.done = btn
      break
    case 'save':
      customizer.actions.save(btn)
      customizer.buttons.save = btn
      break
    case 'clear':
      customizer.actions.clear(btn)
      break
    case 'addtocart':
      customizer.actions.addtocart(btn)
      customizer.buttons.addToCart = btn
      break
    case 'clearlogo':
      customizer.actions.clearlogo(btn)
      break
  }
})

// ======================
// LINE ITEM VARIANTS
// ----------------------
// Modifed event listener based on data-section-trigger NOT data-section

function displaySection(section) {
  customizer.currentSection = section
  customizer.section.forEach(function (sibling) {
    sibling.setAttribute('data-open', false)
  })
  if (section === customizer.sections.cyou.element &&
    !product.type.includes('apron')) {
    customizer.previewGallery.currentImage.dataset.viewImage = 'front'
    customizer.previewGallery.viewsList.classList.remove('show-flex')
    replacePreviewImage(
      customizer.previewGallery.currentImage,
      customizer.cyouColor
    )
  }
  if (section === customizer.menu) {
    if (!product.type.includes('apron'))
      customizer.previewGallery.viewsList.classList.add('show-flex')
    customizer.buttons.back.classList.remove('show')
    customizer.buttons.save.classList.remove('show')
    customizer.title.classList.add('show')
    customizer.buttons.done.classList.add('show')
    document.querySelectorAll('[data-options]').forEach((elem, index) => elem.textContent = getCurrentVariantOptions()[index])
  }

  section.setAttribute('data-open', true)
}

customizer.triggers.forEach(function (trigger) {
  const name = trigger.dataset.sectionTrigger
  const section = document.querySelector(`[data-section=${name}]`)

  switch (name) {
    case 'text':
      customizer.sections.text.inputs = document.querySelectorAll('[data-input="text"]')
      customizer.sections.text.fontInputs = document.querySelectorAll('[data-input="font"]')
      customizer.sections.text.colorInputs = document.querySelectorAll('[data-input="text-color"]')
      customizer.sections.text.notes = document.querySelectorAll('[data-input="text-notes"]')
      customizer.sections.text.previews = document.querySelectorAll('[data-preview="text"]')
      customizer.sections.text.navPreviews = document.querySelectorAll('[data-nav-preview="text"]')
      customizer.sections.text.cost = document.querySelector('[data-cost="text"]')
      customizer.sections.text.element = document.querySelector('[data-section="text"]')
      break
    case 'logo':
      customizer.sections.logo.inputs = document.querySelectorAll('[data-input="logo"]')
      customizer.sections.logo.uploads = document.querySelectorAll('[data-input="upload"]')
      customizer.sections.logo.notes = document.querySelectorAll('[data-input="logo-notes"]')
      customizer.sections.logo.previews = document.querySelectorAll('[data-preview="logo"]')
      customizer.sections.logo.navPreviews = document.querySelectorAll('[data-nav-preview="logo"]')
      customizer.sections.logo.uploadPreviews = document.querySelectorAll('[data-preview="upload"]')
      customizer.sections.logo.cost = document.querySelector('[data-cost="logo"]')
      customizer.sections.logo.element = document.querySelector('[data-section="logo"]')
      break
    case 'flag':
      customizer.sections.flag.inputs = document.querySelectorAll('[data-input="flag"]')
      customizer.sections.flag.notes = document.querySelectorAll('[data-notes="flag"')
      customizer.sections.flag.previews = document.querySelectorAll('[data-preview="flag"]')
      customizer.sections.flag.cost = document.querySelector('[data-cost="flag"]')
      customizer.sections.flag.element = document.querySelector('[data-section="flag"]')
      break
    case 'cyou':
      customizer.sections.cyou.inputs = document.querySelector('[data-input="cyou"]')
      customizer.sections.cyou.cost = document.querySelector('[data-cost="cyou"]')
      customizer.sections.cyou.element = document.querySelector('[data-section="cyou"]')
      break
    case 'cyou-color':
      customizer.sections.cyouColor.previews = document.querySelectorAll('[data-preview="cyou-color"]')
      customizer.sections.cyouColor.input = document.querySelector('[data-input="cyou-color"]')
      customizer.sections.cyou.trigger = document.querySelector('[data-section-trigger="cyou-color"]')
      break
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault()
    displaySection(section)
    customizer.buttons.back.classList.add('show')
    customizer.buttons.done.classList.remove('show')
    customizer.title.classList.remove('show')
    switch (name) {
      case 'select':
        customizer.title.classList.add('show')
        customizer.buttons.back.classList.remove('show')
        customizer.buttons.done.classList.remove('show')
        customizer.buttons.next.classList.add('show')
        break
      case 'nav':
        customizer.buttons.save.classList.remove('show')
        customizer.buttons.done.classList.add('show')
      case 'text':
        customizer.buttons.save.classList.add('show')
        break
      case 'logo':
        customizer.buttons.save.classList.add('show')
        break
      case 'flag':
        customizer.buttons.save.classList.add('show')
        break
      case 'cyou':
        customizer.buttons.save.classList.add('show')
        break
      case 'cyou-color':
        customizer.buttons.save.classList.remove('show')
        break
    }
    if (section.dataset.section == 'text' || section.dataset.section == 'logo' || section.dataset.section == 'flag' || section.dataset.section == 'cyou') {
      for (child of customizer.sections[section.dataset.section].cost.children) {
        if (child.dataset.current == "true" && child.dataset.view == customizer.previewGallery.currentImage.dataset.viewImage && child.textContent) {
          customizer.sections[name].element.dataset.saved = "true"
        }
      }
    }
  })
})

function getCurrentVariantOptions() {
  const vs = product.variantSelect;
 if (vs.selectedIndex < 0) {
  product.variantID = vs.options[0].value;
  return vs.options[0].text.split(' / ')
 } else {
  product.variantID = vs.options[vs.selectedIndex].value;
  return vs.options[vs.selectedIndex].text.split(' / ')
 }
}

function replacePreviewImage(target, cyou) {
  if (product.type.includes('jacket')) {
    const [color, sleeves, size] = getCurrentVariantOptions()
    if (cyou && target.dataset.viewImage === 'front')
      return (target.src = `https://cdn.shopify.com/s/files/1/0763/2745/files/${product.handle
        }-${color.toLowerCase()}-${sleeves.toLowerCase()}-cyou-${cyou}.jpg`)
    target.src = `https://cdn.shopify.com/s/files/1/0763/2745/files/${product.handle
      }-${color.toLowerCase()}-${sleeves.toLowerCase()}-${target.dataset.viewImage
      }.jpg`
  }
  if (product.type.includes('apron')) {
    const [color, size] = getCurrentVariantOptions()
    if (cyou)
      return (target.src = `https://cdn.shopify.com/s/files/1/0763/2745/files/${product.handle
        }-${color.toLowerCase()}-cyou-${cyou}.jpg`)
    target.src = `https://cdn.shopify.com/s/files/1/0763/2745/files/${product.handle
      }-${color.toLowerCase()}-front.jpg`
  }
}

function displayColorName(color, name, id) {
  const colorSplit = color.split('-')
  if (colorSplit.length === 3) {
    const [colorWord1, colorWord2, colorID] = colorSplit
    name.textContent = `${capitalize(colorWord1)} ${capitalize(colorWord2)}`
    id.textContent = `(${colorID})`
  } else if (colorSplit.length === 2) {
    const [colorName, colorID] = colorSplit
    name.textContent = capitalize(colorName)
    id.textContent = `(${colorID})`
  } else {
    name.textContent = capitalize(colorSplit[0])
    id.textContent = `(${colorSplit[colorSplit.length - 1]})`
  }
}

function previewTextColor(target, input, index) {
  target[index].setAttribute('data-color', input)
}

function previewTextFont(target, input, index) {
  target[index].setAttribute('data-font', input)
}

function capitalize(str) {
  if (typeof str === 'string')
    return str.replace(/\b\w/g, (c) => c.toUpperCase())
  return ''
}

function enableFields(...inputs) {
  inputs.forEach((elem) => {
    elem.disabled = false
  })
}

function disableFields(...inputs) {
  inputs.forEach((elem) => {
    elem.value = null
    elem.disabled = true
  })
}

//Change customizer image on variant selection
product.variantSelect.addEventListener('change', () => {
  customizer.previewGallery.images.forEach((elem) => {
    replacePreviewImage(elem, customizer.cyouColor)
  })
})

//View buttons
function changeView(index, isGallery) {
  if (isGallery == true) this.scrollIntoView({behavior: "smooth", block: "end", inline: "center"});
  if (isGallery == false) customizer.previewGallery.viewBtns[index].scrollIntoView({behavior: "smooth", inline: "center"});
  customizer.previewGallery.currentImage.dataset.viewImage = this.dataset.view
  replacePreviewImage( customizer.previewGallery.currentImage, customizer.cyouColor)
  customizer.viewElements.forEach(elem => {
    elem.dataset.current = false
    if (elem.dataset.view.includes(this.dataset.view)) elem.dataset.current = true
  })
  customizer.triggers.forEach(elem => elem.classList.remove('hidden-custom'))
  this.dataset.view == 'front' ? document.querySelector('.customizer__nav').classList.add('customizer__nav--rows') : document.querySelector('.customizer__nav').classList.remove('customizer__nav--rows')
  customizer.section.forEach(elem => {
    if (elem.dataset.saved) elem.dataset.saved = "false"
  })
  if (customizer.clickedItemId) {
    getSectionPrice(priceData, "text-customization");
    getSectionPrice(priceData, "logo-customization");
    getSectionPrice(priceData, "flag-customization");
    checkClear()
  }
}

customizer.buttons.views.forEach((elem, index) => elem.addEventListener('click', changeView.bind(elem, index, false)))
customizer.previewGallery.viewBtns.forEach((elem, index) => elem.addEventListener('click', changeView.bind(elem, index, true)))

//Prevent default beahviour of ENTER key on text input fields.
customizer.container.addEventListener(
  'keydown',
  function (e) {
    if (
      e.keyIdentifier == 'U+000A' ||
      e.keyIdentifier == 'Enter' ||
      e.keyCode == 13
    ) {
      if (e.target.nodeName == 'INPUT' && e.target.type == 'text') {
        e.preventDefault()
        return false
      }
    }
  },
  true
)

function remove(arr, what) {
  what.forEach((value) => {
    var found = arr.indexOf(value)

    while (found !== -1) {
      arr.splice(found, 1)
      found = arr.indexOf(value)
    }
  })
}

function prettify(str) {
  return str.split('-').map(function capitalize(part) {
    return part.charAt(0).toUpperCase() + part.slice(1);
  }).join(' ');
}

function getPropertyName(input) {
  return input.replace(/(^.*\[|\].*$)/g, '')
}

function resetTextSection() {
  customizer.sections.text.inputs.forEach((elem) => {
    if(elem.parentElement.dataset.current == "true") {
      elem.value = ''
      elem.dispatchEvent(new Event('keyup'))
    }
  })
  customizer.sections.text.fontInputs.forEach((elem, index) => {
    if(elem.parentElement.parentElement.dataset.current == "true") {
      elem.selectedIndex = 0
      document.querySelectorAll('.custom-select--font .select-selected')[index].textContent = elem.options[0].textContent
      elem.dispatchEvent(new Event('change'))
    }
  })
  customizer.sections.text.colorInputs.forEach((elem, index) => {
    if(elem.parentElement.parentElement.dataset.current == "true") {
      elem.selectedIndex = 0
      elem.dispatchEvent(new Event('change'))
      document.querySelectorAll('.custom-select--text-color .select-selected')[index].textContent = elem.options[0].textContent
      elem.dispatchEvent(new Event('change'))
    }
  })
  customizer.sections.text.notes.forEach((elem) => {
    if(elem.parentElement.dataset.current == "true") elem.value = ''
  })
  if (product.type.includes('apron'))
    document.getElementById('text-location').selectedIndex = 0
  customizer.sections.text.cost.nextElementSibling.classList.remove('show')
  customizer.sections.text.element.dataset.saved = false
}

function resetLogoSection() {
  customizer.sections.logo.inputs.forEach((elem) => {
    if (elem.parentElement.dataset.current == "true") {
      elem.value = null
      elem.dispatchEvent(new Event('keyup'))
      enableFields(elem)
    }
  })
  customizer.sections.logo.uploads.forEach((elem) => {
    if (elem.parentElement.parentElement.dataset.current == "true") {
      elem.value = null
      elem.dispatchEvent(new Event('change'))
      enableFields(elem)
    }
  })
  customizer.sections.logo.notes.forEach((elem) => {
    if(elem.parentElement.dataset.current == "true") elem.value = ''
  })
  // document.getElementById('additional-logo-location').selectedIndex = 0
  if (product.type.includes('apron'))
    document.getElementById('logo-location').selectedIndex = 0
  customizer.sections.logo.cost.nextElementSibling.classList.remove('show')
  customizer.sections.logo.element.dataset.saved = false
}

function resetFLagSection() {
  customizer.sections.flag.inputs.forEach((elem, index) => {
    if (elem.parentElement.dataset.current == "true") {
      elem.value = null
      elem.dispatchEvent(new Event('keyup'))
      if (elem.id.includes('front')) {
        if (elem.nextElementSibling.selectedIndex) {
          elem.nextElementSibling.selectedIndex = 0
        }
      } else {
        elem.nextElementSibling.selectedIndex = 3
      }
    }
  })
  if (product.type.includes('jacket')) {
    customizer.sections.flag.notes.forEach((elem) => {
      if(elem.parentElement.dataset.current == "true")  {
        elem.value = ''
      }
    })
  }
  customizer.sections.flag.cost.nextElementSibling.classList.remove('show')
  customizer.sections.flag.element.dataset.saved = false
}

function resetCyouSection() {
  const [menuCyouImg, cyouSectionImg, sectionCyouName, sectionCyouId] =
    customizer.sections.cyouColor.previews
  customizer.sections.cyou.inputs.selectedIndex = 0
  customizer.sections.cyou.element.dataset.saved = false
  customizer.sections.cyouColor.input.value = null
  customizer.sections.cyou.variant = null
  customizer.cyouColor = null
  cyouSectionImg.src = null
  menuCyouImg.src =
    'https://cdn.shopify.com/s/files/1/0763/2745/files/customizer-cyou-logo.png'
  replacePreviewImage(customizer.previewGallery.currentImage)
  if (product.type.includes('jacket'))
    replacePreviewImage(customizer.previewGallery.images[1])
  sectionCyouName.parentElement.classList.remove('show-flex')
  customizer.sections.cyou.cost.nextElementSibling.firstElementChild.classList.add('hidden-custom')
  customizer.buttons.colors.forEach((elem) => {
    elem.dataset.selected = "false"
  })
  customizer.sections.cyou.inputs.dispatchEvent(new Event('change'))
}

//Change front customization side for womens jackets
if (product.type.includes('women')) {
  customizer.previewGallery.customizationLayers.forEach(elem => elem.classList.add('left'))
}

if (product.type.includes('apron')) {
  customizer.previewGallery.container.classList.add('single-view')
  customizer.previewGallery.customizationLayers.forEach(elem => elem.classList.add('apron'))
}

if (product.type.includes('jacket')) {
  customizer.previewGallery.customizationLayers.forEach(elem => elem.classList.add('jacket'))
}

const form = document.querySelector(".form");
const formInner = document.querySelector(".form-inner");
const formNav = document.querySelector(".form-nav");
const total = document.querySelector("[data-total-price]");
let navItem = document.querySelectorAll("[data-nav-item]");
const previews = {
  text: document.querySelectorAll('[data-preview="text"]')
}
const navPreviews = {
  text: document.querySelectorAll('[data-nav-preview="text"]')
}
let lineIds = {
  logo: [],
  text: [],
  flag: [],
  cyou: []
};
let priceData = {
  product: [{
    current: true,
    id: product.variantID,
    price: product.variantPrice
  }],
  logo: [],
  text: [],
  flag: [],
  cyou: []
};

let uploads = 0
async function getIds(el, arr, type) {
  arr.splice(0, arr.length);
  hasUpload = false
  if (el.selectedIndex === 0 || el.selectedIndex === 1) {
    arr.push(0)
    if (el.selectedIndex === 1) {
      id = el.options[el.selectedIndex].dataset.id;
      arr[0] = id;
    }
  } else {
    el.forEach(function (item, index) {
      let id;
      arr.push(0);
      if (item.value !== "") {
          id = item.dataset.id;
          arr[index] = id;
        if (customizer.sections.logo.uploads[index]) {
          if (customizer.sections.logo.uploads[index].value) hasUpload = true
        }
      } else {
        arr[index] = 0;
      }
    });
  }
  if (type === 'logo') {
    uploads = 0
    let uploadFiles = []
    files.forEach(elem => {if (elem) uploadFiles.push(elem)})
    uploads = new Set(uploadFiles).size
    let fees = await getProduct('logo-registration-fee')
    if (uploads !== 0) lineIds.logo[4] = fees.variants[uploads-1].id.toString()
  }
}

async function getProduct(handle) {
  let response = await fetch(window.Shopify.routes.root + `products/${handle}.js`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })
  let data = await response.json();
  return data;
}

async function getPrice(arr, handle, type) {
  priceData[type] = []
  let customizationItem = await getProduct(handle);
  for (const [index, variant] of customizationItem.variants.entries()) {
    let variantID = variant.id.toString();
    let variantPrice = variant.price;
    if (arr.includes(variantID)) {
      let obj = {
        input: customizer.sections[type].inputs[index],
        id: variantID,
        price: variantPrice
      };
      if (priceData[type].length !== -1) {
        const index = priceData[type].findIndex((obj) => obj.id === variantID);
        if (index === -1) {
          priceData[type].push(obj);
        }
      } else {
        priceData[type].push(obj);
      }
    }
  }
  if (type === 'logo' && arr.length === 5) {
    if (!priceData.logo.some(obj => Object.keys(obj).includes('fee'))) {
      let fees = await getProduct('logo-registration-fee')
      priceData.logo.push({
      fee: "true",
      id: fees.variants[uploads-1].id.toString(),
      price: fees.variants[uploads-1].price
    });
    }
    priceData.logo = priceData.logo.filter((value, index) => {
      const _value = JSON.stringify(value);
      return index === priceData.logo.findIndex(obj => {
        return JSON.stringify(obj) === _value;
      });
    });
  }
  return priceData[type];
}

function getSectionPrice(data, handle) {
  let type = handle.replace("-customization", "");
  data = data[type]
  let sectionCosts = 0;
  for (let i in data) {
    if (data[i].input) {
      if (data[i].input.parentElement.dataset.current === "true") {
        let cost = data[i].price;
        cost = Math.floor(cost / 1e2)
        sectionCosts += cost;
      }
    }
  }
  if (sectionCosts) {
    if (type === "text" || type === "logo"  || type === "flag") {
      for (child of customizer.sections[type].cost.children) {
        if (child.dataset.current == "true") {
          child.textContent = `$${sectionCosts}`
          if (child.dataset.addFee) child.textContent = `$${sectionCosts} + $${child.dataset.addFee} fee`
        }
      }
    } else {
      customizer.sections[type].cost.textContent =  `$${sectionCosts}`
    }
  } else {
    if (type === "text" || type === "logo"  || type === "flag") {
      if ( customizer.sections[type].cost) {
        for (child of customizer.sections[type].cost.children) {
          if (child.dataset.current == "true") child.textContent = ``
        }
      }
    } else {
      customizer.sections[type].cost.textContent =  ``
    }
  }
}

function getTotalPrice() {
  const items = [
    ...priceData.product,
    ...priceData.text,
    ...priceData.logo,
    ...priceData.flag,
    ...priceData.cyou
  ];
  let totalCosts = 0;
  for (let a in items) {
    let cost = items[a].price;
    cost = Math.floor(cost / 1e2)
    totalCosts += cost;
  }
  customizer.totalCost.innerHTML =  `$${totalCosts}`
  customizer.totalAdditionalCost = totalCosts - Math.floor(product.variantPrice / 1e2)
}


async function field(handle) {
  customizer.buttons.save.classList.add('disabled')
  let type = handle.replace("-customization", "");
  await getIds(customizer.sections[type].inputs, lineIds[type], type);
  await getPrice(lineIds[type], handle, type);
}

async function customOptionsInput(handle) {
  await field(handle);
  customizer.buttons.save.classList.remove('disabled')
  getTotalPrice();
  getSectionPrice(priceData, handle);
  customizer.selectedVariants = [...lineIds.text, ...lineIds.logo, ...lineIds.flag, ...lineIds.cyou]
}

function dynamicOutline(target) {
  target.textContent
    ? target.classList.add('outline')
    : target.classList.remove('outline')
}

function getTextColors(index) {
  if (!product.type.includes('apron')) {
    if (index || index == 0 ) {
      if (getCurrentVariantOptions()[0].toLowerCase() === 'black')
       customizer.sections.text.previews[index].setAttribute('data-color', 'white-1801')
      if (getCurrentVariantOptions()[0].toLowerCase() === 'white')
        customizer.sections.text.previews[index].setAttribute('data-color', 'black-1800')
    } else {
    if (getCurrentVariantOptions()[0].toLowerCase() === 'black')
      customizer.sections.text.previews.forEach(elem => elem.setAttribute('data-color', 'white-1801'))
    if (getCurrentVariantOptions()[0].toLowerCase() === 'white')
      customizer.sections.text.previews.forEach(elem => elem.setAttribute('data-color', 'black-1800'))
    }
  }
}

if (customizer.sections.text.inputs) {
  getTextColors()
  customizer.sections.text.inputs.forEach((field, index) => {
    field.addEventListener("keyup", () => {
      customizer.sections.text.fontInputs.forEach(elem => {
        if (elem.selectedIndex > 0) {
          customizer.sections.text.fontInputs[index].value = elem.value
          document.querySelectorAll('.custom-select--font .select-selected')[index].textContent = elem.value
          customizer.sections.text.fontInputs[index].dispatchEvent(new Event('change'))
        }
      })
      customOptionsInput(field.dataset.handle)
      customizer.sections.text.previews[index].textContent = field.value;
      customizer.sections.text.navPreviews[index].textContent = field.value;
      dynamicOutline(customizer.sections.text.previews[index])
      if (index === 0 && field.value === '' || index === 3 && field.value === '' || index === 4 && field.value === '' || index === 6 && field.value === '') {
        customizer.sections.text.navPreviews[index].textContent = 'Name/Title'
      }
    });
  });
  
  customizer.sections.text.fontInputs.forEach((elem, index) => {
    elem.addEventListener('change', () => {
      previewTextFont(customizer.sections.text.previews, elem.value, index)
      previewTextFont(customizer.sections.text.navPreviews, elem.value, index)
      dynamicOutline(customizer.sections.text.previews[index])
    })
  })
  
  customizer.sections.text.colorInputs.forEach((elem, index) => {
    elem.addEventListener('change', () => {
      previewTextColor(customizer.sections.text.previews, elem.value, index)
      previewTextColor(customizer.sections.text.navPreviews, elem.value, index)
      dynamicOutline(customizer.sections.text.previews[index])
      if (!elem.value) {
        getTextColors(index)
      }
    })
  })
}
const files = [0, 0, 0, 0]
if (customizer.sections.logo.inputs) {
  customizer.sections.logo.inputs.forEach((elem, index) => {
    elem.addEventListener('keyup', logoInput.bind(elem, index))
    function logoInput(index) {
      customOptionsInput(elem.dataset.handle)
      if (this.value) {
        customizer.sections.logo.uploads[index].disabled = true
        customizer.sections.logo.uploads[index].nextElementSibling.disabled = true
        customizer.sections.logo.uploads[index].nextElementSibling.classList.add('disabled')
        customizer.sections.logo.previews[index].classList.add('outline')
        customizer.sections.logo.previews[index].src =
          'https://cdn.shopify.com/s/files/1/0763/2745/files/placeholder-logo.png'
        customizer.sections.logo.navPreviews[index].src =
          'https://cdn.shopify.com/s/files/1/0763/2745/files/placeholder-logo.png'
      } else {
        customizer.sections.logo.uploads[index].disabled = false
        customizer.sections.logo.uploads[index].nextElementSibling.disabled = false
        customizer.sections.logo.uploads[index].nextElementSibling.classList.remove('disabled')
        customizer.sections.logo.previews[index].classList.remove('outline')
        customizer.sections.logo.previews[index].src = ''
        customizer.sections.logo.navPreviews[index].src = 'https://cdn.shopify.com/s/files/1/0763/2745/files/Clement_Design_USA_Logo_New_Mid_Dark.png?v=1614301473'
      }
    }
  })
  
  customizer.sections.logo.uploads.forEach((elem, index) => {
    elem.addEventListener('change', logoUpload.bind(elem, index))
    function logoUpload(index) {
     if (this.files.length > 0) {
        if(this.files[0].size > 1048576){
          alert("File is too big! Please upload an image smaller than 2mb.");
          this.value = "";
          return
        };
     }
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        const uploaded_image = reader.result
        customizer.sections.logo.uploadPreviews[index].parentElement.classList.add('show-flex')
        customizer.sections.logo.uploadPreviews[index].src = uploaded_image
        customizer.sections.logo.previews[index].src = uploaded_image
        customizer.sections.logo.navPreviews[index].src = uploaded_image
      })
      if (this.value) {
        customizer.sections.logo.inputs[index].value = ` `
        customizer.sections.logo.inputs[index].disabled = true
        reader.readAsDataURL(this.files[0])
        customizer.sections.logo.previews[index].classList.add('outline')
        if (!files.includes(this.value)) {
          // if (index === 1) {
          //   files[0] === 0 ? customizer.sections.logo.cost.children[0].setAttribute('data-add-fee', '75') : customizer.sections.logo.cost.children[0].setAttribute('data-add-fee', '150')
          // } else {
            // index === 0 ? customizer.sections.logo.cost.children[0].setAttribute('data-add-fee', '75') :  customizer.sections.logo.cost.children[index-1].setAttribute('data-add-fee', '75')
            customizer.sections.logo.cost.children[index].setAttribute('data-add-fee', '75')
          // }
        }
        files[index] = this.value
      } else {
        files[index] = 0
        customizer.sections.logo.inputs[index].value = ``
        customizer.sections.logo.uploadPreviews[index].parentElement.classList.remove('show-flex')
        customizer.sections.logo.inputs[index].disabled = false
        customizer.sections.logo.previews[index].src = ''
        customizer.sections.logo.uploadPreviews[index].src = ''
        customizer.sections.logo.navPreviews[index].src = 'https://cdn.shopify.com/s/files/1/0763/2745/files/Clement_Design_USA_Logo_New_Mid_Dark.png?v=1614301473'
        customizer.sections.logo.previews[index].classList.remove('outline')
        // index === 0 ? customizer.sections.logo.cost.children[0].setAttribute('data-add-fee', '') : customizer.sections.logo.cost.children[index-1].setAttribute('data-add-fee', '')
        customizer.sections.logo.cost.children[index].setAttribute('data-add-fee', '')
      }
      customOptionsInput(elem.dataset.handle)
    }
  })
}

if (customizer.sections.flag.inputs) {
  customizer.sections.flag.inputs.forEach((field) => {
    field.addEventListener("keyup", () => customOptionsInput(field.dataset.handle))
  });
}

if (customizer.sections.cyou.inputs) {
  const [menuCyouImg, cyouSectionImg, sectionCyouName, sectionCyouId] = customizer.sections.cyouColor.previews
  customizer.buttons.colors.forEach((elem) => {
    elem.addEventListener('click', changeSelectedColor.bind(elem))
    function changeSelectedColor() {
      customizer.buttons.colors.forEach(elem => elem.dataset.selected = "false")
      elem.dataset.selected = "true"
      customizer.cyouColor = this.dataset.cyouColor
      customizer.sections.cyouColor.input.value = this.dataset.cyouColor
      customizer.sections.cyou.inputs.selectedIndex = 1
      cyouSectionImg.src = `https://cdn.shopify.com/s/files/1/0763/2745/files/${customizer.cyouColor}.png`
      cyouSectionImg.alt = customizer.cyouColor
      displayColorName(customizer.cyouColor, sectionCyouName, sectionCyouId) 
      cyouSectionImg.parentElement.parentElement.classList.add('show-flex')
      //Preview CYOU
      replacePreviewImage(
        customizer.previewGallery.currentImage,
        customizer.cyouColor
      )
      if (!product.type.includes('apron')) {
        replacePreviewImage(
          customizer.previewGallery.images[1],
          customizer.cyouColor
        )
      }
      menuCyouImg.src = `https://cdn.shopify.com/s/files/1/0763/2745/files/${customizer.cyouColor}.png`
      displaySection(customizer.sections.cyou.element)
      customizer.buttons.save.classList.add('show')
      customizer.sections.cyou.inputs.dispatchEvent(new Event('change'))
    }
  })

  customizer.sections.cyou.inputs.addEventListener('change', () => {
    customOptionsInput(customizer.sections.cyou.inputs.dataset.handle)
  })
}

function removeElementsWithValue(arr, val) {
  var i = arr.length;
  while (i--) {
      if (arr[i] === val) {
          arr.splice(i, 1);
      }
  }
  return arr;
}
document.addEventListener('DOMContentLoaded',init,false);

const customizerForm = document.querySelector(".customizer__form");
const inputElements = Array.from(customizerForm.querySelectorAll("input, select:not(.single-option-selector), checkbox, textarea"))
inputElements.push(document.querySelector('#quantity'))
async function removeCartItems() {
  try {
    const result = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET'
    })
    const cart = await result.json()
    const itemList = []
    for (item of cart.items) {
      if (Object.values(item.properties).includes(customizer.clickedItemId)) {
        const lineItem = {
          title: item.title,
          key: item.key,
          variantID:item.id,
          quantity: 0,
        }
        itemList.push(lineItem)
      }
    }

    let formData = {
      'updates': {}
    }

    for (item of itemList) {
      formData['updates'][item.key] = 0
    }

    let info = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(response => response.json()).then(data => {
      localStorage.removeItem(`customdata-${customizer.clickedItemId}`)
      return console.log(data)
    }).then(() => {
    }).catch((error) => {
      console.error('Error:', error);
    });
  } catch (error) {
    console.log(error)
  }
}
async function init() {
  const clickedItem = window.localStorage.getItem('clickedItem')
  let cached = getForm()

  if (cached) {
    customizer.buttons.addToCart.textContent = 'Save'
    customizer.buttons.customize.classList.add('disabled')
    customizer.buttons.customize.textContent = 'Loading...'
    customizer.clickedItemId = clickedItem
    let cyouButton = null;
    for (const [index, input] of inputElements.entries()) {
      if (!input.classList.contains('single-option-selector')) {
        if (input.dataset.input != "upload") input.value = cached[index].value
        if (input.dataset.input == "font") {
          if (cached[index].value) {
            const cachedFont = input.parentElement.querySelector(`.select-items [data-font="${cached[index].value}"]`)
            cachedFont.dispatchEvent(new Event('click'))
          } else {
            input.parentElement.querySelector('.select-selected').textContent =  'Select Font';
          }

        }
        if (input.dataset.input == "text-color" && cached[index].value) {
          const cachedColor = input.parentElement.querySelector(`.select-items [data-text-color="${cached[index].value}"]`)
          cachedColor.dispatchEvent(new Event('click'))
        }
        if (cached[index].name.includes('Flag') || cached[index].name.includes('Flag')) {
          if (cached[index].name.includes('name')) {
            if (input.id.includes('front')) {
              if (input.nextElementSibling.selectedIndex) {
                input.nextElementSibling.selectedIndex = 0
              }
            } else {
              input.nextElementSibling.selectedIndex = 3
            }
          }
        }
        if (cached[index].name) {
          if (cached[index].name.includes('CYOU Color')) {
            customizer.buttons.colors.forEach((elem) => {
              if (elem.dataset.cyouColor == cached[index].value) cyouButton = elem;
            })
          }
          if (cached[index].name.includes('Upload')) {
            // if (cached[index].name.includes('Logo Upload 1')) newIndex = 0
            // if (cached[index].name.includes('Logo Upload 2')) newIndex = 1
            // if (cached[index].name.includes('Right')) newIndex = 2
            // if (cached[index].name.includes('Back')) newIndex = 3
            // if (cached[index].name.includes('Left')) newIndex = 4
            if (cached[index].name.includes('Logo Upload 1')) newIndex = 0
            if (cached[index].name.includes('Right')) newIndex = 1
            if (cached[index].name.includes('Back')) newIndex = 2
            if (cached[index].name.includes('Left')) newIndex = 3
            if (cached[index].value && cached[index].value != 'data:,') {
              customizer.sections.logo.uploadPreviews[newIndex].parentElement.classList.add('show-flex')
              customizer.sections.logo.uploadPreviews[newIndex].src = "data:image/png;base64," + cached[index].value;
              customizer.sections.logo.previews[newIndex].src = "data:image/png;base64," + cached[index].value;
              customizer.sections.logo.navPreviews[newIndex].src = "data:image/png;base64," + cached[index].value;
              customizer.sections.logo.inputs[newIndex].value = "Previously uploaded image: data:image/png;base64," + cached[index].value
              customizer.sections.logo.inputs[newIndex].disabled = true
              customizer.sections.logo.previews[newIndex].classList.add('outline')
              if (!files.includes("data:image/png;base64," + cached[index].value)) {
                // if (newIndex === 1) {
                //   files[0] === 0 ? customizer.sections.logo.cost.children[0].setAttribute('data-add-fee', '75') : customizer.sections.logo.cost.children[0].setAttribute('data-add-fee', '150')
                // } else {
                //   newIndex === 0 ? customizer.sections.logo.cost.children[0].setAttribute('data-add-fee', '75') : customizer.sections.logo.cost.children[newIndex-1].setAttribute('data-add-fee', '75')
                // }
                customizer.sections.logo.cost.children[newIndex].setAttribute('data-add-fee', '75')
              }
              files[newIndex] = "data:image/png;base64," + cached[index].value;
              customOptionsInput(customizer.sections.logo.uploads[newIndex].dataset.handle)
            }
          }
        }
        if (input.type == "text") {
          input.dispatchEvent(new Event('keyup'));
        } else if (input.dataset.input != "upload") {
          input.dispatchEvent(new Event('change'));
        }
      }
    }
    customizer.totalAdditionalCost = parseInt(product.additionalCostField.value)
    setTimeout(() => {
      if (cyouButton) cyouButton.dispatchEvent(new Event('click'))
      checkClear()
      document.querySelector('.product_gallery_nav').querySelector('.is-nav-selected').dispatchEvent(new Event('click'))
      Array.from(customizer.buttons.views).slice().reverse().forEach(elem => elem.dispatchEvent(new Event('click')))
      customizer.buttons.customize.classList.remove('disabled')
      customizer.buttons.customize.textContent = 'EDIT'
      document.querySelector('.customizer__product-variant--product').classList.add('show-flex')
      customizer.buttons.customize.dispatchEvent(new Event('click'))
      customizer.buttons.done.dispatchEvent(new Event('click'))
    }, "3000")
  }

  function getForm() {
    let f = window.localStorage.getItem(`customdata-${clickedItem}`);
    if(f) return JSON.parse(f);
  }
  localStorage.removeItem("clickedItem");
}

function checkClear() {
  const costData = document.querySelectorAll('[data-cost]')
  costData.forEach((elem, index) => {
    if (elem.dataset.cost == 'text' || elem.dataset.cost == 'logo' || elem.dataset.cost == 'flag') {
      elem.children.forEach((elem, index) => {
        if (elem.textContent) elem.parentElement.nextElementSibling.children[index].classList.remove('hidden-custom')
      })
    } else {
      if (elem.textContent) elem.nextElementSibling.firstElementChild.classList.remove('hidden-custom')
    }
  })
}

function getBase64Image(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;

  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);

  var dataURL = canvas.toDataURL("image/png");

  return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
}

function handleData(id) {
  let form = {}
  for (const [index, input] of inputElements.entries()) {
    if (input.type == "file") {
      let img = input.parentElement.previousElementSibling.querySelector('img');
      if (img.src) form[index] =  {name: input.name.replace("properties[",""), value: getBase64Image(img) }
      if (input.value == null) input.remove()
    } else {
      form[index] = {name: input.name.replace("properties[",""), value: input.value }
      if (input.value == null) input.remove()
    }
  }

  saveData(form, id)
}
function deteleUnusedFields() {
  for (const [index, input] of inputElements.entries()) {
      if (input.value == null) input.remove()
  }
}

function saveData(form, id) {
	let f = JSON.stringify(form);
  try {
    window.localStorage.setItem(id, f);
  } catch(e) {
    alert('Storage is full. Edit customization link will not be available in cart.')
  }
}
